import { BeneficioService, SolicitudPremioService } from "services/comunicacion-cultura";
import { loadingAtom, openModalSolicitarPremioAtom } from "../store/store";
import { useAtom } from "jotai";
import { message } from "antd";
import usePuntosPage from "./usePuntosPage";

const useModalSolicitarPremio = () => {

    const [open, setOpen] = useAtom(openModalSolicitarPremioAtom);
    const [loading, setLoading] = useAtom(loadingAtom);
    const { fetchSolicitudesPremios } = usePuntosPage();

    const abrirModal = () => {
        setOpen(true);
    }

    const cerrarModal = () => {
        setOpen(false);
    }

    const guardar = async (formInstance) => {
        console.log("guardar...")
        formInstance
            .validateFields()
            .then(async (payload) => {
                try {
                    setLoading(true);
                    await SolicitudPremioService.insertar(payload);
                    fetchSolicitudesPremios();
                    setLoading(false);
                    formInstance.resetFields();
                    cerrarModal();
                } catch (error) {
                    if (error.response && error.response.data) {
                        const mensajeError = error.response.data.mensaje;
                        console.log('Error del servidor:', mensajeError);
                        message.error(mensajeError);
                    }
                } finally {
                    setLoading(false);
                }
            })
            .catch((info) => {
                console.log('Validate Failed:', info);
                setLoading(false);
            });
    }

    return {
        open,
        loading,
        abrirModal,
        cerrarModal,
        guardar
    };
};

export default useModalSolicitarPremio;